var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['plv-ia-popup', _vm.customClass]},[_vm._t("others"),_vm._v(" "),_c('div',{staticClass:"plv-ia-popup__wrap"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }